import React from 'react';
import * as styles from './Swatch.module.css';

const Swatch = (props) => {
  const {data, setActiveSwatch, isActive, withLabel = false} = props;
  
  return (
    <div className={styles.swatchWrap} onClick={() => setActiveSwatch(data)} role="presentation">
      <div className={`${styles.swatch} ${isActive === true ? styles.isActive: ''}`}>
        <div style={{backgroundColor: (data.color || data.label.toLowerCase())}} className={styles.circle}></div>
      </div>
      {withLabel && (
        <span className={styles.label}>{data.color || data.label}</span>
      )}
    </div>
  );
};

export default Swatch;
